export default __webpack_public_path__ + "static/media/final _illustrator_logo.7036384e.jpg";